import {
    getAllProposedParkingRateRegulations,
    getSelectedParkingRateBatchData,
    isEditParkingRatesInProgress,
    parkingRateListViewFiltersReceived,
    proposedParkingBatchRegulationsReceived,
    proposedParkingRateRegulationsReceived,
    setChosenParkingRates,
    setDisabledIds,
    setRegulationType,
    setSelectedParkingRateColumns,
    showParkingBatchListView,
    showParkingRateListView,
    storeProposedParkingRateRegulationsParams,
    toggleEditParkingRatesOptionsPanel,
    toggleParkingRateActionPerformed
} from "./../../actions/regulation/EditParkingRates/index";
import { createReducer } from "@reduxjs/toolkit";
import { EditParkingRatesState } from "../../actions/regulation/EditParkingRates/types";

const initialState: EditParkingRatesState = {
    regulationType: [],
    parkingRates: [],
    isEditParkingRatesOptionsPanelOpen: false,
    disabledIds: [],
    isEditParkingRatesInProgress: false,
    proposedParkingRateRegulations: {
        meta: {
            count: 0,
            next: null,
            previous: null
        },
        results: []
    },
    proposedParkingRateBatchRegulations: {
        meta: { count: 0 },
        results: []
    },
    showParkingRateListView: false,
    selectedColumns: [],
    showParkingBatchListView: false,
    isFetchingParkingRateRegulations: false,
    proposedParkingRateRegulationsParams: {},
    actionPerformed: false,
    parkingRateListViewFilters: [],
    isFetchingParkingBatchData: true
};

const editParkingRates = createReducer(initialState, (builder) => {
    builder
        .addCase(setRegulationType, (state, action) => {
            state.regulationType = action.payload.regulationType;
        })
        .addCase(setChosenParkingRates, (state, action) => {
            state.parkingRates = action.payload.parkingRates;
        })
        .addCase(toggleEditParkingRatesOptionsPanel, (state, action) => {
            state.isEditParkingRatesOptionsPanelOpen = action.payload.isOpen;
        })
        .addCase(toggleParkingRateActionPerformed, (state) => {
            state.actionPerformed = !state.actionPerformed;
        })
        .addCase(setDisabledIds, (state, action) => {
            state.disabledIds = action.payload.disabledIds;
        })
        .addCase(setSelectedParkingRateColumns, (state, action) => {
            state.selectedColumns = action.payload.selectedColumns;
        })
        .addCase(isEditParkingRatesInProgress, (state, action) => {
            state.isEditParkingRatesInProgress = action.payload.inProgress;
        })
        .addCase(proposedParkingRateRegulationsReceived, (state, action) => {
            state.proposedParkingRateRegulations = action.payload.proposedParkingRateRegulations;
            state.isFetchingParkingRateRegulations = false;
        })
        .addCase(getAllProposedParkingRateRegulations, (state, action) => {
            state.isFetchingParkingRateRegulations = true;
        })
        .addCase(proposedParkingBatchRegulationsReceived, (state, action) => {
            state.isFetchingParkingBatchData = false;
            state.proposedParkingRateBatchRegulations =
                action.payload.proposedParkingRateBatchRegulations;
        })
        .addCase(showParkingRateListView, (state, action) => {
            state.showParkingRateListView = action.payload.showParkingRateListView;
        })
        .addCase(showParkingBatchListView, (state, action) => {
            state.showParkingBatchListView = action.payload.showParkingBatchListView;
        })
        .addCase(getSelectedParkingRateBatchData, (state, action) => {
            state.isFetchingParkingBatchData = true;
        })
        .addCase(storeProposedParkingRateRegulationsParams, (state, action) => {
            state.proposedParkingRateRegulationsParams = action.payload.params;
        })
        .addCase(parkingRateListViewFiltersReceived, (state, action) => {
            state.parkingRateListViewFilters = action.payload.data;
        })
        .addDefaultCase((state) => state);
});

export default editParkingRates;
